import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import SubNav from 'components/SubNav';
import SponsorNav from 'components/SponsorNav';
import { Logo } from 'components/svgs/LogedInUserLogo';
import HeaderAva from 'styles/img/no-ava.png';
import {
  PROVIDER_MY_WEBINARS,
  WEBINARS,
  CREATE_COURSE_ONLINE,
  PROVIDERS,
} from 'stores/WorkshopsUrlConstants';
import clickOutside from 'react-click-outside';
import {IACP_LOGO, ACI_LOGO} from 'constants/sponsor_logos';


const canShowLinksToWorkshopLinkList = [
  '/',
  'online_workshops',
  'regular_workshops',
  'provider_bios'
];
const MAX_IDLE_MINS = 30;

@withRouter
@inject('user', 'alert', 'SponsorStore')
@observer
export default class UserLoggedInNavbar extends React.Component {
  state = { openedHamburger: false, canShowLinksToWorkshop: false };

  openHamburger = () => {
    this.setState({ openedHamburger: true });
  };

  componentDidMount = () => {
    this.handleCanShowlinks(location);
    this.routerListener = this.props.history.listen(location => {
      this.setState({ openedHamburger: false });
      this.handleCanShowlinks(location);
      this.triggerPopup(location);
    });
    // this.setupAutoLogout();
  };

  componentWillUnmount() {
    if (this.idleInterval)
      clearInterval(this.idleInterval);

    document.removeEventListener('mousemove', (e) => {
      this.idleTime = 0;
    });

    document.removeEventListener('keyPress', (e) => {
      this.idleTime = 0;
    });
  }

  setupAutoLogout = () => {
    this.idleTime = 0;
    this.idleInterval = setInterval(this.timerIncrement, 60000);

    document.addEventListener('mousemove', (e) => {
      this.idleTime = 0;
    });
    document.addEventListener("keyPress", (e) => {
      this.idleTime = 0;
    }, false);
  }

  timerIncrement = () => {
    this.idleTime = this.idleTime + 1;
    if (this.idleTime >= MAX_IDLE_MINS) {
      this.logout();
      clearInterval(this.idleInterval);
    }
  }

  triggerPopup = ({pathname}) => {
    const {governing_body} = this.props.user.user || {};
    if (governing_body === 'iacp' && pathname === '/' && this.props.location.pathname.includes('iacp')) {
      this.props.alert.success(`You are now leaving the IACP members area.
      To return please click on the 'IACP Members Area' button
      at the top of the Therapy Academy homepage.`, 5000);
    } else if (governing_body === 'aci' && pathname === '/' && this.props.location.pathname.includes('aci')) {
      this.props.alert.success(`You are now leaving the ACI members area.
      To return please click on the 'ACI Members Area' button
      at the top of the Therapy Academy homepage.`, 5000);
    }
  }

  closeHamburger = () => {
    this.setState({ openedHamburger: false });
  };

  logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('purchaseMessageSeen');
    localStorage.removeItem('@coupon');
    this.props.history.push('/');
    this.props.user.setUser(null);
  };

  logoutAsProvider = () => {
    const adminToken = localStorage.getItem('adminToken');
    const adminUser = localStorage.getItem('adminUser');
    localStorage.setItem('token', adminToken);
    localStorage.setItem('user', adminUser);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    this.props.history.push('/');
    this.props.user.setUser(JSON.parse(adminUser));
  }

  redirectOnline = () => {
    this.props.history.replace('/online_workshops', {cpd_hours: true});
  };

  redirectOther = () => {
    this.props.history.replace('/online_workshops', {other: true});
  };

  redirectToGroup = () => {
    this.props.history.replace('/online_workshops', {group: true});
  };

  redirectToRegular = () => {
    this.props.history.push('/regular_workshops');
  };

  redirectProviderBios = () => {
    this.props.history.push('/provider_bios');
  };

  redirectIACP = () => {
    this.props.history.push('/iacp');
  };
  redirectACI = () => {
    this.props.history.push('/aci');
  };

  handleCanShowlinks(location) {
    if (
      canShowLinksToWorkshopLinkList.some(link =>
        location.pathname.includes(link)
      )
    )
      this.setState({ canShowLinksToWorkshop: true });
    else this.setState({ canShowLinksToWorkshop: false });
  }

  componentWillUnmount = () => {
    this.routerListener();
  };

  renderHeader(isHidden) {
    const {sponsorId} = this.props.SponsorStore;
    const {governing_body, proffession_description} = this.props.user.user;
    const {location, isNavbarStatic} = this.props;
    const canShowLinksToWorkshop = className => {
      if (this.state.canShowLinksToWorkshop) {
        return (
          <div
            className={`${className ? className : 'hide_mobile'}`}
            style={{justifyContent: 'center'}}
            key='canShowLinksToWorkshop'
          >
            {/* <span
              className="add-workshop nav-btn btn prime bordered"
              onClick={this.redirectOnline}
            >
              cpd workshops
            </span> */}
            {/* <span
              className="add-workshop nav-btn btn bordered black"
              onClick={this.redirectProviderBios}
            >
              Provider bios
            </span> */}
            {/* <span
              className="add-workshop nav-btn btn bordered black"
              onClick={this.redirectOther}
            >
              Other workshops
            </span> */}
            {/* <span
              className="add-workshop nav-btn btn bordered blue"
              onClick={this.redirectToRegular}
            >
              Regular workshops
            </span> */}
             {/* <span
              className="add-workshop nav-btn btn bordered blue"
              onClick={this.redirectToGroup}
            >
              Group supervision
            </span> */}
            {className && governing_body === 'iacp' && (
              <span
                className="add-workshop nav-btn btn prime bordered"
                onClick={this.redirectIACP}
                style={{margin: 0}}
              >
                 IACP Members Area
              </span>

              //<Link to='/iacp' className='spns-link'>
              //  <img src={IACP_LOGO} alt="IACP"/>
              //</Link>
            )}
            {className && governing_body === 'aci' && (
              <span
                className="add-workshop nav-btn btn prime bordered"
                onClick={this.redirectACI}
                style={{margin: 0}}
              >
                 ACI Members Area
              </span>

              //<Link to='/iacp' className='spns-link'>
              //  <img src={IACP_LOGO} alt="IACP"/>
              //</Link>
            )}
          </div>
        )
      }
    }

    const regularNavbar = (
      <div className="spons-logo" style={{alignSelf: 'center', flexBasis: 'auto', flex: 1}} key='regular_navbar'>
        <div className="menu">
          {proffession_description !== 'General Public' && (
            <Link to={CREATE_COURSE_ONLINE} className="add-workshop add-workshop-button">
              CREATE YOUR WORKSHOP
              <br /><span>it's free</span>
            </Link>
          )}
          <span className="hamburger" onClick={this.openHamburger}>
            <i className="ic-menu-ico" />
          </span>
        </div>
        <RightBar
          active={this.state.openedHamburger}
          logout={this.logout}
          logoutAsProvider={this.logoutAsProvider}
          closeHamburger={this.closeHamburger}
          admin={this.props.user.getUser().role === 'admin'}
          coach={this.props.user.getUser().role === 'coach'}
          history={this.props.history}
          username={`${this.props.user.getUser().first_name} ${this.props.user.getUser().last_name}`}
          isGeneralPublic={proffession_description === 'General Public'}
        />
      </div>
    )

    const iacpLogo = className => (
      <div className={`spons-logo ${className}`} style={{alignSelf: 'center', flexBasis: 'auto', flex: 1, justifyContent: 'flex-end'}}>
        <div className="menu">
          <Link to='/iacp' className="iacp-logo">
            <img src={IACP_LOGO} alt="IACP" style={{maxWidth: '58px'}} />
          </Link>
          <span className="hamburger" onClick={this.openHamburger}>
            <i
              className="ic-menu-ico"
              style={{
                color: '#2b353c',
                alignSelf: 'center',
                marginLeft: '16px',
              }}
            />
          </span>
        </div>
        <RightBar
          active={this.state.openedHamburger}
          logout={this.logout}
          logoutAsProvider={this.logoutAsProvider}
          closeHamburger={this.closeHamburger}
          admin={this.props.user.getUser().role === 'admin'}
          coach={this.props.user.getUser().role === 'coach'}
          history={this.props.history}
          iacpMenu
          username={`${this.props.user.getUser().first_name} ${this.props.user.getUser().last_name}`}
        />
      </div>
    )
    const aciLogo = className => (
      <div className={`spons-logo ${className}`} style={{alignSelf: 'center', flexBasis: 'auto', flex: 1, justifyContent: 'flex-end'}}>
        <div className="menu">
          <Link to='/aci' className="iacp-logo">
            <img src={ACI_LOGO} alt="ACI" width='120px' />
          </Link>
          <span className="hamburger" onClick={this.openHamburger}>
            <i
              className="ic-menu-ico"
              style={{
                color: '#2b353c',
                alignSelf: 'center',
                marginLeft: '16px',
              }}
            />
          </span>
        </div>
        <RightBar
          active={this.state.openedHamburger}
          logout={this.logout}
          logoutAsProvider={this.logoutAsProvider}
          closeHamburger={this.closeHamburger}
          admin={this.props.user.getUser().role === 'admin'}
          coach={this.props.user.getUser().role === 'coach'}
          history={this.props.history}
          iacpMenu
          username={`${this.props.user.getUser().first_name} ${this.props.user.getUser().last_name}`}
        />
      </div>
    )

    const linksTo = canShowLinksToWorkshop();
    let notSponsor = [linksTo, regularNavbar];
    const visiblePosition = !isNavbarStatic ? 'fixed' : '';
    const hiddenDisplay = isHidden && isNavbarStatic ? 'none' : '';
    // console.log(isNavbarStatic, isHidden, isNavbarStatic && isHidden)
    return (
      <header
        className={
          classNames(`main-header`, {
            'iacp-header': location.pathname.includes('iacp') || location.pathname.includes('aci'),
          })
        }
        style={
          // location.pathname === '/iacp' || location.pathname === '/' ?
            // {visibility: isHidden ? 'hidden' : 'visible', position: isHidden ? 'relative' : 'fixed'} :
            {visibility: isHidden ? 'hidden' : 'visible', position: isHidden ? 'relative' : visiblePosition, display: hiddenDisplay}
        }
      >
        <div className="container-fluid">
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{
                display: 'flex',
                flex: 1,
                alignItems: 'flex-start',
                alignSelf: 'center',
                flexWrap: 'wrap',
              }}
            >
              <div>
                <Link
                  to={proffession_description === 'General Public' ? '/public_webinars' : '/webinars'}
                  className="logo"
                  key='logo'
                >
                  {Logo}
                </Link>
              </div>
              <div
                className="hide_mobile"
                style={{minWidth: '100px'}}
              >
                <Link to="/myprofile/editprofile" className="profile" key='editprofile'>
                  <span className="profile-name">
                    <span className="profile-first-name">
                      {this.props.user.getUser().first_name}
                    </span>
                    <span className="profile-surname">
                      {this.props.user.getUser().last_name}
                    </span>
                  </span>
                </Link>
              </div>
              {this.props.location.pathname.includes('iacp') || this.props.location.pathname.includes('aci') ?
                <div className='ta-members-area' style={{justifyContent: 'center', alignSelf: 'center'}}>
                  <Link to={`/webinars`}
                    className="add-workshop nav-btn btn prime bordered"
                    onClick={this.triggerPopup}
                    style={{
                      backgroundColor: '#2b353c',
                      color: 'white',
                      textTransform: 'capitalize',
                      marginBottom: 0,
                    }}
                    key='webinars'
                  >
                    TherapyAcademy Area
                  </Link>
                </div>
              : null}
              {(sponsorId !== 'iacp' && sponsorId !== 'aci') && canShowLinksToWorkshop('ta-members-area')}
            </div>
            {this.props.location.pathname.includes('iacp') || this.props.location.pathname.includes('aci') ? (
              <div className='workshop-wrapper ta-members-area-mob' style={{justifyContent: 'center'}}>
                <Link to={`/webinars`}
                  className="add-workshop nav-btn btn prime bordered"
                  onClick={this.triggerPopup}
                  key='aci_webinars'
                  style={{
                    backgroundColor: '#2b353c',
                    color: 'white',
                    textTransform: 'capitalize',
                  }}
                >
                  TherapyAcademy Area
                </Link>
              </div>
            ) : null}
            {(sponsorId == 'iacp') && iacpLogo('iacp-area-menu')}
            {(sponsorId == 'aci') && aciLogo('iacp-area-menu')}
            {(sponsorId !== 'iacp' && sponsorId !== 'aci') && canShowLinksToWorkshop('ta-members-area-mob')}
            {location.pathname.includes('iacp') && (
              <div
                className="iacp-title"
                style={{
                  maxWidth: '400px',
                  alignSelf: 'center',
                }}
              >
                <p>Irish Association for Counselling and Psychotherapy Members Area</p>
              </div>
            )}
            {location.pathname.includes('aci') && (
              <div
                className="iacp-title"
                style={{
                  maxWidth: '400px',
                  alignSelf: 'center',
                }}
              >
                <p>Addiction Counsellors of Ireland</p>
              </div>
            )}
            {
              !location.pathname.includes('iacp') &&
              !location.pathname.includes('aci') &&
              proffession_description !== 'General Public' &&
              (governing_body === 'iacp' || governing_body === 'aci') ? (
                <div
                  className="iacp-title"
                  style={{
                    alignItems: 'center',
                    justifyContent: "center",
                    margin: '0 8px',
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: '22px',
                      color: '#fff',
                    }}
                  >
                    TherapyAcademy Area
                  </p>
                </div>
              ) : null
            }
            {sponsorId == 'iacp' ? iacpLogo('hide_mobile') :
            (sponsorId == 'aci' ? aciLogo('hide_mobile') : notSponsor)}
          </div>
          {sponsorId ? <SponsorNav /> : <SubNav isHidden={isHidden} /> }
        </div>
      </header>
      // <header
      //   className={
      //     classNames('main-header', {
      //       'iacp-header': this.props.location.pathname.includes('iacp'),
      //     }, {
      //       'iacp-header': this.props.location.pathname.includes('aci'),
      //     }
      //   )}
      //   style={
      //     location.pathname === '/iacp' || location.pathname === '/' ?
      //       {position: 'fixed'} :
      //       {}
      //   }
      // >
      //   <div className="container-fluid">
      //     <div className="row">
      //       <div
      //         style={{
      //           display: 'flex',
      //           flex: 1,
      //           alignItems: 'flex-start',
      //           alignSelf: 'center',
      //         }}
      //         // className='col-lg-4'
      //       >
      //         <div
      //           className={proffession_description !== 'General Public' ?
      //             "col-3 col-sm-2 col-lg-2" :
      //             "col-3 col-sm-3 col-lg-3"
      //           }
      //         >
      //           <Link
      //             to={proffession_description === 'General Public' ? '/public_webinars' : '/webinars'}
      //             className="logo"
      //           >
      //             {Logo}
      //           </Link>
      //         </div>
      //         <div
      //           className={proffession_description !== 'General Public' ?
      //             "col-7 col-md-4 col-lg-4 hide_mobile" :
      //             "col-10 col-md-7 col-lg-6 hide_mobile"
      //           }
      //         >
      //           <Link to="/myprofile/editprofile" className="profile">
      //             {/* <span className="profile-avatar">
      //               {this.props.user.getUser().avatar_url ? (
      //                 <img src={this.props.user.getUser().avatar_url} />
      //               ) : (
      //                 <img src={HeaderAva} alt="avatar" />
      //               )}
      //             </span> */}
      //             <span className="profile-name">
      //               <span className="profile-first-name">
      //                 {this.props.user.getUser().first_name}
      //               </span>
      //               <span className="profile-surname">
      //                 {this.props.user.getUser().last_name}
      //               </span>
      //             </span>
      //           </Link>
      //         </div>
      //         {this.props.location.pathname.includes('iacp') || this.props.location.pathname.includes('aci') ?
      //           <div className='workshop-wrapper col-5 col-md-6 ta-members-area' style={{justifyContent: 'center', alignSelf: 'center'}}>
      //             <Link to={`/webinars`}
      //               className="add-workshop nav-btn btn prime bordered"
      //               // className="col bottom-header-content"
      //               onClick={this.triggerPopup}
      //               style={{
      //                 backgroundColor: '#2b353c',
      //                 color: 'white',
      //                 textTransform: 'capitalize',
      //                 marginBottom: 0,
      //               }}
      //             >
      //               TherapyAcademy Area
      //             </Link>
      //           </div>
      //         : null}
      //         {(sponsorId !== 'iacp' && sponsorId !== 'aci') && canShowLinksToWorkshop('col-5 col-md-6 ta-members-area')}
      //       </div>
      //       {this.props.location.pathname.includes('iacp') || this.props.location.pathname.includes('aci') ?
      //         <div className='workshop-wrapper ta-members-area-mob' style={{justifyContent: 'center'}}>
      //           <Link to={`/webinars`}
      //             className="add-workshop nav-btn btn prime bordered"
      //             // className="col bottom-header-content"
      //             onClick={this.triggerPopup}
      //             style={{
      //               backgroundColor: '#2b353c',
      //               color: 'white',
      //               textTransform: 'capitalize',
      //             }}
      //           >
      //             TherapyAcademy Area
      //           </Link>
      //         </div>
      //         :null}
      //       {sponsorId == 'iacp' && iacpLogo('iacp-area-menu')}
      //       {(sponsorId !== 'iacp' && sponsorId !== 'aci') && canShowLinksToWorkshop('ta-members-area-mob')}

      //       { this.props.location.pathname.includes('iacp') && (
      //         <div className="iacp-title col-md-6 col-lg-4">
      //           <p>Irish Association for Counselling and Psychotherapy Members Area</p>
      //         </div>
      //       )}
      //       { this.props.location.pathname.includes('aci') && (
      //         <div className="iacp-title col-md-6 col-lg-4">
      //           <p>Addiction Counsellors of Ireland</p>
      //         </div>
      //       )}
      //       {
      //         !this.props.location.pathname.includes('iacp') &&
      //         !this.props.location.pathname.includes('aci') &&
      //         proffession_description !== 'General Public' &&
      //         (governing_body === 'iacp' || governing_body === 'aci') ? (
      //           <div
      //             className="iacp-title col-md-6 col-lg-4"
      //             style={{
      //               display: "flex",
      //               alignItems: 'flex-start',
      //               alignSelf: "center",
      //               paddingLeft: '75px',
      //               justifyContent: 'flex-end',
      //             }}
      //           >
      //             <p
      //               style={{
      //                 margin: 0,
      //                 fontSize: '22px',
      //                 color: '#fff',
      //               }}
      //             >
      //               TherapyAcademy Area
      //             </p>
      //           </div>
      //         ) : null
      //       }
      //       {sponsorId == 'iacp' ? iacpLogo('col-4 hide_mobile') :
      //       (sponsorId == 'aci' ? aciLogo : notSponsor)}

      //     </div>
      //     {sponsorId ? <SponsorNav /> : <SubNav /> }
      //   </div>
      // </header>
    );
  }

  render() {
    const visible = this.renderHeader();
    const hidden = this.renderHeader(true);
    const headers = [visible, hidden];
    return <div>{headers}</div>;
  }
}

@clickOutside
@inject('user')
class RightBar extends React.Component {
  state = { active: false, admin: false, coach: false };

  componentWillReceiveProps = newProps => {
    this.setState({
      active: newProps.active,
      admin: newProps.admin,
      coach: newProps.coach
    });
  };

  handleClickOutside() {
    if (this.state.active) this.props.closeHamburger();
  }

  redirectToLive = () => {
    this.props.history.push('/webinars');
  }

  redirectToOnline = () => {
    this.props.history.push('/online');
  }

  redirectToGroup = () => {
    this.props.history.replace('/public_webinars');
  };

  redirectToPublic = () => {
    this.props.history.replace('/public_workshops');
  }

  redirectToOrganizations = () => {
    this.props.history.replace('/online_workshops', {organizations: true});
  }

  render() {
    const adminUser = localStorage.getItem('adminUser');
    const {governing_body} = this.props.user.user;
    const {iacpMenu, isGeneralPublic} = this.props;
    return iacpMenu ? (
      <div className={classNames({ sidebar: true, active: this.state.active })}>
        <div className="workshop-holder">
          <div className="auth-holder">
            <ul className="sidebar-workshop-list border">
              {/* <li>
                <div className="col-3 col-sm-2 col-lg-2">
                  <Link to='/' className="logo">
                    {Logo}
                  </Link>
                </div>
              </li> */}
              <li>
                <Link
                  to="/"
                  key="my_workshops1111"
                  className="work-item online"
                >
                  FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/myprofile/editprofile"
                  key="my_workshops1111"
                  className="work-item online username-link"
                >
                  PROFILE
                </Link>
              </li>
              <li>
                <Link
                  to="/webinars"
                  key="my_workshops1111"
                  className="work-item online"
                >
                  TherapyAcademy Area
                </Link>
              </li>
            </ul>
            <ul className="sidebar-workshop-list border">
              <li>
                <Link to="/contacts" className="list-item">
                  Contact Us
                </Link>
              </li>
            </ul>
            <div className="btn-holder border">
              <a
                href="#"
                className="btn bordered logout"
                onClick={() => this.props.logout()}
              >
                log out
              </a>
            </div>
            <span className="hamburger" onClick={() => this.props.closeHamburger()}>
              <i className="ic-close-ico" />
            </span>
          </div>
        </div>
      </div>
    ) : (
      <div className={classNames({ sidebar: true, active: this.state.active })}>
        <div className="workshop-holder">
          <div className="auth-holder">
            <ul className="sidebar-workshop-list border">
              {this.state.admin && [
                <li key='my_workshops1111'>
                  <Link
                    to="/adminpanel/approve_workshop"
                    key="my_workshops1111"
                    className="work-item online"
                  >
                    ADMIN DASHBOARD
                  </Link>
                </li>,
                <li key='my_workshops'>
                  <Link
                    to={PROVIDER_MY_WEBINARS}
                    key="my_workshops"
                    className="work-item online"
                  >
                    PROVIDER DASHBOARD
                  </Link>
                </li>,
                <li key='providers'>
                  <Link
                    to={PROVIDERS}
                    key="providers"
                    className="work-item online"
                  >
                    PROVIDERS
                  </Link>
                </li>,
                <li key='reports'>
                  <Link
                    to='/reports'
                    key="reports"
                    className="work-item online"
                  >
                    REPORTS
                  </Link>
                </li>,
              ]}
              {this.state.admin && (
                <li>
                  <Link
                    to='/provider/trainee_responses'
                    key="reports"
                    className="work-item online"
                  >
                    TRAINEE RESPONSES
                  </Link>
                </li>
              )}
              {this.state.coach && [
                <li>
                  <Link
                    to={PROVIDER_MY_WEBINARS}
                    key="my_workshops"
                    className="work-item online"
                  >
                    PROVIDER DASHBOARD
                  </Link>
                </li>,
                <li>
                  <Link
                    to='/provider/trainee_responses'
                    key="reports"
                    className="work-item online"
                  >
                    TRAINEE RESPONSES
                  </Link>
                </li>
              ]}
              {!isGeneralPublic && (
                <li>
                  <Link
                    to={WEBINARS}
                    key="provider_workshops"
                    className="work-item online"
                  >
                    REGULAR DASHBOARD
                  </Link>
                </li>
              )}
              {governing_body === 'iacp' && (
                <li>
                  {/* <Link to='/iacp' className='spns-link'>
                    <img src={IACP_LOGO} alt="IACP"/>
                  </Link> */}
                  <Link
                    to='/iacp'
                    key="provider_workshops"
                    className="work-item online"
                  >
                    IACP MEMBERS AREA
                  </Link>
                </li>
              )}
              {governing_body === 'aci' && (
                <li>
                  <Link to='/aci' className='spns-link'>
                    <img src={ACI_LOGO
                    } alt="ACI"/>
                  </Link>
                </li>
              )}
            {/* <ul className="sidebar-workshop-list border"> */}
            {isGeneralPublic ? [
              <li key='PUBLIC_WEBINARS'>
                <span onClick={this.redirectToGroup} className="work-item online">PUBLIC WEBINARS</span>
              </li>,
              <li key='PUBLIC_WORKSHOPS'>
                <span onClick={this.redirectToPublic} className="work-item online">PUBLIC WORKSHOPS</span>
              </li>
            ] : [
              <li key='LIVE'>
                <span onClick={this.redirectToLive} className="work-item online">LIVE WEBINARS</span>
              </li>,
              <li key='ONLINE'>
                <span onClick={this.redirectToOnline} className="work-item online">ONLINE WORKSHOPS</span>
              </li>,
              <li key='PUBLIC_WEBINARS'>
                <span onClick={this.redirectToGroup} className="work-item online">PUBLIC WEBINARS</span>
              </li>,
              <li key='PUBLIC_WORKSHOPS'>
                <span onClick={this.redirectToPublic} className="work-item online">PUBLIC WORKSHOPS</span>
              </li>,
              // {/* <li>
              //   <span onClick={this.redirectToOrganizations} className="work-item online">ORGANISATIONS</span>
              // </li> */}
              <li key='CREATE'>
                <Link to="/create_course_online" className="work-item online">CREATE WORKSHOP</Link>
              </li>
            ]}
              <li>
                <Link to="/our_services" className="work-item online">OUR SERVICES</Link>
              </li>
              <li>
                <Link to="/organisations-info" className="work-item online">ORGANISATIONAL LEARNING</Link>
              </li>
              <li>
                <Link to="/about-us" className="work-item online">ABOUT US</Link>
              </li>
              <li>
                <Link to="/provider_bios" className="work-item online">PROVIDER BIOS</Link>
              </li>
              <li>
                <Link to="/" className="work-item online">FAQs</Link>
              </li>
              <li>
                <Link
                  to="/myprofile/editprofile"
                  key="my_workshops1111"
                  className="work-item online username-link"
                >
                  PROFILE
                </Link>
              </li>
            </ul>
          </div>

          {/* <Link
            to={CREATE_COURSE_ONLINE}
            key="create_w321312312orkshops"
            className="work-item online"
          >
            CREATE YOUR WORKSHOP ONLINE
            <br /><span>it's free</span>
          </Link> */}
        </div>
        <ul className="sidebar-workshop-list border">
          <li>
            <Link to="/contacts" className="list-item">
              Contact Us
            </Link>
          </li>
          {/* <li>
            <Link to="/termsofconditions" className="list-item">
              Terms of Service
            </Link>
          </li>
          <li>
            <Link to="/providerterms" className="list-item">
              Provider Terms
            </Link>
          </li>
          <li>
            <Link to="/privacypolicy" className="list-item">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/cookiespolicy" className="list-item">
              Cookies Policy
            </Link>
          </li>
          <li>
            <Link to="/subprocessors" className="list-item">
              Sub-Processors
            </Link>
          </li> */}
        </ul>
        <div className="btn-holder border">
          <a
            href="#"
            className="btn bordered logout"
            onClick={() => this.props.logout()}
          >
            log out
          </a>
          {adminUser &&
            <a
              href="#"
              className="btn bordered logout"
              style={{marginTop: '16px'}}
              onClick={() => this.props.logoutAsProvider()}
            >
              log out as provider
            </a>
          }
        </div>
        <ul className="social">
          <li>
            <a
              href="https://www.facebook.com/TherapyAcademy/"
              target="_blank"
              className="fa fa-facebook-square"
            />
          </li>
          <li>
            <a
              href="https://twitter.com/academy_therapy"
              target="_blank"
              className="fa fa-twitter-square"
            />
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/therapy-academy/"
              target="_blank"
              className="fa fa-linkedin-square"
            />
          </li>
        </ul>
        <span className="hamburger" onClick={() => this.props.closeHamburger()}>
          <i className="ic-close-ico" />
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserLoggedInNavbar.jsx